import { ICellRendererParams } from '@ag-grid-community/core';

import './BtnEditRenderer.css';

const BtnEditRenderer = (props: ICellRendererParams) => {
    return (
      <img src="images/edit.svg" className="grid_edit_btn" alt="edit button" />
    );
  };
 
export default BtnEditRenderer;